const translationsGB = {
  "-- Select option --": "-- Select option --",
  "About Our Speaker": "About Our Speaker",
  "add-google-calendar": "Add to Google calendar",
  agenda: "Agenda",
  All: "All",
  "All categories": "All categories",
  "All locations": "All locations",
  "and-book": "and book",
  "back-to-events": "Back to events",
  "BK Event": "BK Event",
  "book-only": "Book only",
  Centre: "Centre",
  Close: "Close",
  Conference: "Conference",
  "Contact Email": "Contact Email",
  "Copied event address to clipboard ...":
    "Copied event address to clipboard ...",
  "Could not retrieve event due to an error":
    "Could not retrieve event due to an error",
  Course: "Course",
  day: "Day",
  days: "Days",
  description: "Description",
  "enter-search": "Enter search ...",
  event_plural: "events",
  event: "event",
  "go-to-page": "Go to page",
  "Group session": "Group session",
  hours: "Hours",
  "Import on Google Calendar": "Import on Google Calendar",
  "Join Zoom meeting": "Join Zoom meeting",
  Lecture: "Lecture",
  Meditation: "Meditation",
  minutes: "minutes",
  Miscellaneous: "Miscellaneous",
  month: "Month",
  month_January: "January",
  month_February: "February",
  month_March: "March",
  month_April: "April",
  month_May: "May",
  month_June: "June",
  month_July: "July",
  month_August: "August",
  month_September: "September",
  month_October: "October",
  month_November: "November",
  month_December: "December",
  "More details": "More details",
  "More informations about this event on":
    "More informations about this event on",
  next: "Next",
  "No events found": "No events found ...",
  "no event id": "No event id. Please add the event id (?eventId=<id>) to the URL.",
  of: "of",
  "online_state_In Person": "In Person",
  online_state_Mixed: "Online and In Person",
  online_state_None: "All events",
  online_state_Online: "Online",
  "Online activity": "Online activity",
  "Online State": "Online State",
  "Open webcast URL": "Watch Live",
  "other-sessions": "Other Sessions",
  Overbooked: "Overbooked",
  page: "Page",
  "Panel discussion": "Panel discussion",
  "Power and protection": "Power and protection",
  previous: "Previous",
  Private: "Private",
  "read-more": "Read more",
  Retreat: "Retreat",
  search: "Search",
  seconds: "seconds",
  Seminar: "Seminar",
  "Share on Facebook": "Share on Facebook",
  "Share on Twitter": "Share on Twitter",
  "Share via Email": "Share via Email",
  show: "Show",
  "Show less": "Show less",
  "Show more": "Show more",
  "Show required fields": "Show required fields",
  "Similar Events": "Similar Events",
  "Special event": "Special event",
  Table: "Table",
  to: "to",
  "To get started, edit <1>src/App.js</1> and save to reload.":
    "To get started, edit <1>src/App.js</1> and save to reload.",
  today: "Today",
  Training: "Training",
  "upcoming-dates": "Upcoming Dates",
  week: "Week",
  weekday_FR: "FR",
  weekday_MO: "MO",
  weekday_SA: "SA",
  weekday_SU: "SU",
  weekday_TH: "TH",
  weekday_TU: "TU",
  weekday_WE: "WE",
  Workshop: "Workshop",
  "Your time": "Your time",
  "There are no more seats available for this event!":
    "There are no more spaces available for this event! Please try to book another date.",
};

module.exports = {
  translationsGB,
};
